export const BLOCK_NATIVE_API_KEY = 'bd60f4c8-b723-4b66-9306-bfba7930c44c'

const GRAPH_URIS = {
  1: 'https://api.thegraph.com/subgraphs/name/arcxmoney/contracts',
  4: 'https://api.thegraph.com/subgraphs/name/arcxmoney/contracts-rinkeby',
  21: 'https://api.thegraph.com/subgraphs/name/gtupak/arcx-playnet',
  42: 'https://api.thegraph.com/subgraphs/name/arcxmoney/contracts-kovan',
  1337: 'https://api.thegraph.com/',
}

export function getGraphURI(chainId: number, isPlaynetActivated: boolean) {
  return GRAPH_URIS[(isPlaynetActivated && 21) || chainId || 1]
}
